import { GlobalEnumerationsAceStudienabschluss, KontaktDisplayModelFormGroup, StipendiumDisplayModelFormGroup } from '@/api/model-index';
import { Constants } from '@/constants';
import { EnumValue } from '@/core/models/enumvalue.model';
import { I18nService } from '@/core/services/i18nService';
import { StateService } from '@/core/services/state.service';
import { TextBoxService } from '@/core/services/textbox.service';
import { Component, Input, OnInit } from '@angular/core';
import { Validators } from '@angular/forms';
import { NumberFormatOptions } from '@progress/kendo-angular-intl';

@Component({
    selector: 'stipendium',
    templateUrl: './stipendium.component.html',
    styleUrls: ['./stipendium.component.scss'],
    standalone: false
})
export class StipendiumComponent implements OnInit {
  @Input('form') public stipendiumForm: StipendiumDisplayModelFormGroup;  

  public currencyFormatOptions: NumberFormatOptions = Constants.CURRENCY_FORMAT_OPTIONS;

  public get dateFormat(): string{
    return this.translateService.GetCurrentShortDateFormat(true);
  }

  public get angestrebterStudienabschlussList(): EnumValue[] {
    return this.translateService.getEnumValues(GlobalEnumerationsAceStudienabschluss);
  }

  constructor(public translateService: I18nService, protected stateService: StateService, protected textBoxService: TextBoxService) { 
  }

  noMinDate(): Date {
    return new Date(0, 0, 1);
  }
  
  ngOnInit(): void {
    this.stipendiumForm.Title.disable();
    this.stipendiumForm.BeantragteFoerdersumme.disable();

    if (this.stateService.IsEndvalidationEnabled) {
      this.stipendiumForm.Title.addValidators(Validators.required);
      this.stipendiumForm.Studienbeginn.addValidators(Validators.required);
      this.stipendiumForm.Studienende.addValidators(Validators.required);
      this.stipendiumForm.Studienfach.addValidators(Validators.required);
      this.stipendiumForm.Universitaet.addValidators(Validators.required);
      this.stipendiumForm.AngestrebterStudienabschluss.addValidators(Validators.required);
      this.stipendiumForm.Immatrikulationsnummer.addValidators(Validators.required);
      this.stipendiumForm.markAllAsTouched();
    }
  }
  
  onStudienbeginnChange(event: any): void {
    this.stipendiumForm.Studienende.setValue(null);
  }
}
